import { setDefaultOptionWithId } from '../actions/setDefaultOptionWithId';
import getStore from '../store/store';
import { trace } from 'owa-trace';
import { mutator } from 'satcheljs';

export const setDefaultOptionWithMutator = mutator(setDefaultOptionWithId, actionMessage => {
    const defaultOptionsUI = getStore().defaultOptionsUI;
    trace.info(`[setDefaultOptionWithMutator] Setting default for id ${actionMessage.id}`);
    defaultOptionsUI.set(actionMessage.id, {
        critiqueTypeInfo: actionMessage.critiqueTypeInfo,
        categoryId: actionMessage.categoryId,
    });
});
